import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b0483c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "required"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 서비스 이용약관 ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " / ", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 개인정보 처리방침 ")
const _hoisted_7 = { class: "form-item-agreement" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*", -1))
const _hoisted_9 = { class: "form-item-agreement" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*", -1))
const _hoisted_11 = { class: "form-item-agreement" }

import { reactive, ref } from 'vue';
  import { useI18n } from 'vue-i18n';

  type AgreeItem = {
    key: string;
    text: string;
    required?: boolean;
    jumpText?: string;
    slug?: string;
  }

  type Form = {
    [propName: string]: any;
  }
  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const selectSignupCondictions = ref<string[]>([]);
  const checkboxForm = reactive<Form>({
    agree1: false,
    agree2: false,
    subscribeTcInformation: false,
  });
  const { t, locale } = useI18n();
  const isKo = locale.value === 'ko';
  const koAgreeList: AgreeItem[] = [
    { key: 'ko1', required: true, text: '만 14세 이상임을 확인해 주세요' },
    { key: 'ko2', required: true, text: '약관을 읽고 모든 항목에 동의합니다.', slug: 'privacy_policy_kr_1' },
    { key: 'ko3', required: true, text: '개인정보 수집·이용하는데 동의하십니까?', jumpText: '개인정보 수집·이용 내역(필수)', slug: 'privacy_policy_kr_2' },
    { key: 'ko4', required: true, text: '개인정보를 제3자에게 제공하는데 동의하십니까?', jumpText: '개인정보 제3자 제공 내역(필수)', slug: 'privacy_policy_kr_3' },
    { key: 'ko5', required: true, text: '개인정보를 국외 제3자에게 제공하는데 동의하십니까?', jumpText: '개인정보 국외 제3자 제공 내역(필수)', slug: 'privacy_policy_kr_4' },
    // 跟 ko3 重复了，Edward 跟客户确认，需要加上。为了代码里面跟 ko3 区分开，text 最后特意加了一个空格，不要删掉
    { key: 'ko6', text: '개인정보 수집·이용하는데 동의하십니까? ', jumpText: '개인정보 수집·이용 내역(선택)', slug: 'privacy_policy_kr_5' },
  ];

  //  const agreeAllChecked = computed(() => {
  //    if (checkboxForm.subscribeTcInformation) {
  //      if (isKo) {
  //         return koAgreeList.length - 1 === selectSignupCondictions.value.length;
  //       } else {
  //         return checkboxForm.agree1 && checkboxForm.agree2;
  //       }
  //    }
  //    return false;
  // });

  // function handleAgreeAllChange(event: any) {
  //   const checked = event as boolean;
  //   checkboxForm.subscribeTcInformation = checked;
  //   if (isKo) {
  //     selectSignupCondictions.value = checked ? koAgreeList.map(({ text }) => text) : [];
  //   } else {
  //     checkboxForm.agree1 = checked;
  //     checkboxForm.agree2 = checked;
  //   }
  // }

return (_ctx: any,_cache: any) => {
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", null, [
    isKo
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(koAgreeList, (item) => {
          return _createElementVNode("div", {
            key: item.key,
            class: "form-item-agreement"
          }, [
            _createElementVNode("div", null, [
              _createVNode(_component_b_form_checkbox, {
                modelValue: selectSignupCondictions.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectSignupCondictions).value = $event)),
                value: item.text,
                required: item.required,
                name: "signup_condictions"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.text) + " ", 1),
                  (item.required)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, "*"))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["modelValue", "value", "required"])
            ]),
            (item.jumpText)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_router_link, {
                    target: "_blank",
                    to: { name: 'staticPage', params: { slug: item.slug } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.jumpText), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              : _createCommentVNode("", true),
            (item.key === 'ko2')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_router_link, {
                    target: "_blank",
                    to: { name: 'staticPage', params: { slug: 'terms_of_use' } }
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }),
                  _hoisted_5,
                  _createVNode(_component_router_link, {
                    target: "_blank",
                    to: { name: 'staticPage', params: { slug: 'privacy_policy' } }
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        }), 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_b_form_checkbox, {
              modelValue: _unref(checkboxForm).agree1,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(checkboxForm).agree1) = $event)),
              value: true,
              required: "",
              name: "agree1"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('Please confirm you are 14 years of age or older')) + ". ", 1),
                _hoisted_8
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_b_form_checkbox, {
              modelValue: _unref(checkboxForm).agree2,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(checkboxForm).agree2) = $event)),
              value: true,
              required: "",
              name: "agree2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('agree.0')) + " ", 1),
                _createVNode(_component_router_link, {
                  target: "_blank",
                  to: { name: 'staticPage', params: { slug: 'service_terms_and_conditions' } }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('agree.1')), 1)
                  ]),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(_unref(t)('agree.2')) + " ", 1),
                _createVNode(_component_router_link, {
                  target: "_blank",
                  to: { name: 'staticPage', params: { slug: 'privacy_policy' } }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('agree.3')), 1)
                  ]),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(_unref(t)('agree.4')) + ". ", 1),
                _hoisted_10
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ], 64)),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_b_form_checkbox, {
        modelValue: _unref(checkboxForm).subscribeTcInformation,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(checkboxForm).subscribeTcInformation) = $event)),
        value: true,
        name: "subscribe_tc_information"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('Sign up to receive updates about TerraCycle and our programs')) + "! ", 1)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})